import Vue from 'vue';
import { UserStore } from '@/services/indexedDB.service';
import router from '@/router';

const getDefaultState = () => {
    return {
        user: null,
        account: 0,
        currentPlan: {
            next_bill: {
                next_charge_amount: null,
            },
            plan_quota: {
                used_storage: null,
                max_storage: null,
            },
            users: {
                added: null,
            }
        },
    };
};

const User = {
    namespaced: true,

    state: getDefaultState(),

    mutations: {
        SET_USER: async (state, user) => {
            state.user = user;
        },

        SET_ACTIVE_ACCOUNT: (state) => {
            state.account = state.user;
        },

        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },

        SET_CURRENT_PLAN: (state, payload) => {
            state.currentPlan = payload;
        },

        SET_TERMS_OF_SALE_AGREEMENT: (state, payload) => {
            Vue.set(state.user, 'terms_of_sale_agreement', payload);
        }
    },

    actions: {
        resetState: ({ commit }) => {
            commit('RESET_STATE');
        },

        store: async ({ commit }, payload) => {
            await UserStore.setItem('email', payload.email);
            await UserStore.setItem('niceName', payload.niceName);
            await UserStore.setItem('displayName', payload.displayName);
        },

        fetchUser: ({ commit, dispatch }) => {
            return new Promise((resolve, reject) => {
                Vue.prototype.$apiService
                    .get('user')
                    .then(async response => {
                        response.data.user_meta = {
                            email: await UserStore.getItem('email'),
                            niceName: await UserStore.getItem('niceName'),
                            displayName: await UserStore.getItem('displayName'),
                            ...response.data.user_meta,
                        };
                        commit('SET_USER', response.data);
                        commit('SET_ACTIVE_ACCOUNT');
                        resolve(response.data);
                    })
                    .catch(err => {
                        dispatch('resetAll', null, { root: true });
                        router.push({ name: 'login' });
                        window.vm.$snackbar('You have been automatically logged out because your session has expired. Please log back in.', 'error');
                        reject(err.response);
                    });
            });
        },
    },

    getters: {
        activeAccounts: state => {
            return state.user.accounts.filter(account => account.accepted);
        },

        user: state => {
            return state.user;
        },

        isCurrentPlanFree: (state, getters, rootState) => {
            return false;
        },

        isPlanProfessional: state => {
            if (!state.user) return;
            if (!state.user.activeSubscription) return;
            if (state.user.activeSubscription.product.sku !== 'professional') return;

            return true;
        },

        isLoggedIn: state => {
            if (state.user) return true;
            else return false;
        },

        isGuest: state => {
            if (state.account.role_id == 7) return true;
            else return false;
        },
    },
};

export default User;
